import { GetAccountsResponse } from '@iwoca/lapi-client/edge';
import { mergeStates } from '../../../iwProvider/StoreHelper';
import { buildRepaymentScheduleState } from './RepaymentScheduleHelper';
import {
    AD_HOC_AMOUNT_REPAYMENT_SCHEDULE_MODAL_DATA,
    REPAYMENT_SCHEDULE_MODAL_DATA
} from './RepaymentScheduleModal.actions';

const initialState = {
    repayments: [],
    totalBalance: 0,
    totalInterest: 0,
    totalPrincipal: 0,
    totalRepayment: 0,
    totalFees: 0,
    hasFees: false
};

export type TSchedule = NonNullable<
    NonNullable<
        GetAccountsResponse['data']
    >['accounts'][number]['scheduled_payments']
>;

type TState = {
    repayments: NonNullable<TSchedule['schedule']>;
    totalBalance?: number;
    totalInterest: number;
    totalPrincipal: number;
    totalRepayment: number;
    totalFees: number;
    hasFees: boolean;
};

type TAction =
    | { type: typeof REPAYMENT_SCHEDULE_MODAL_DATA; schedule: TSchedule }
    | {
          type: typeof AD_HOC_AMOUNT_REPAYMENT_SCHEDULE_MODAL_DATA;
          schedule: TSchedule;
      };

// eslint-disable-next-line import/no-default-export
export default function (
    state: TState = mergeStates(initialState),
    action: TAction
): TState {
    switch (action?.type) {
        case REPAYMENT_SCHEDULE_MODAL_DATA:
        case AD_HOC_AMOUNT_REPAYMENT_SCHEDULE_MODAL_DATA:
            return mergeStates(buildRepaymentScheduleState(action.schedule));

        default:
            return state;
    }
}
